template = require('./holding_chart.html.slim')

angular.module('wbComponents').directive 'wbHoldingChart', ['$log', ($log) ->
  restrict: 'E'
  scope:
    data: '='
    date: '@'
    value: '@'
  replace: true
  templateUrl: template
  link: ($scope, $el, $attrs) ->
    createTickScale = (start, end, count = 4) ->
      interval = end - start
      for i in [0..count-1]
        start + i*interval/(count-1)

    dateName = $scope.date or 'date'
    valueName = $scope.value or 'value'
    $scope.$watch 'data', (data) ->
      return unless data?
      $scope.filteredData = _.map data, (d) ->
        date: +moment(d[dateName])
        value: +d[valueName]

    [valueMin, valueMax, valueTicks] = [null, null, null]
    $scope.valueTicks = ->
      return unless $scope.filteredData? and $scope.filteredData.length
      min = _($scope.filteredData).map('value').min()
      max = _($scope.filteredData).map('value').max()
      # Hack to workaround Angular's terrible digest behaviour
      # try to remove with Angular 2
      return valueTicks if valueMin is min and valueMax is max
      [valueMin, valueMax] = [min, max]
      valueTicks = createTickScale(min, max)

    [dateStart, dateEnd, dateTicks] = [null, null, null]
    $scope.dateTicks = ->
      return unless $scope.filteredData? and $scope.filteredData.length
      start = $scope.filteredData[0]
      end = $scope.filteredData.slice(-1)[0]
      # Hack to workaround Angular's terrible digest behaviour
      # try to remove with Angular 2
      return dateTicks if dateStart is start and dateEnd is end
      [dateStart, dateEnd] = [start, end]
      dateTicks = createTickScale(start.date, end.date, 4) if start isnt undefined

    $scope.yDomain = (data) ->
      values = _.map(data, 'value')
      maxValue = _.max(values)
      minValue = _.min(values)
      spread = maxValue - minValue
      values.push(maxValue + spread * 0.25)
      values
]
